import { type SecondaryCategory } from '@webapp/core/entities/internal/SecondaryCategory'
import {
  CatalogAccessGrid,
  type CatalogAccessGridMessages,
} from '@webapp/modules/purchasing/components/CatalogAccessGrid'
import { type CatalogPermissionUserConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionUserConfig'
import messages from './messages'

export interface ISecondaryCategoryAccessGridProps {
  user: CatalogPermissionUserConfig
  secondaryCategoryOptions: SecondaryCategory[]
  isLoading: boolean
  isSaving: boolean
  onSave: (selectedSecondaryCategoryIds: number[]) => void
  onCancel?: () => void
}

const gridMessages: CatalogAccessGridMessages = {
  header: messages.departmentsAccessHeader,
  selectAll: messages.selectAll,
  deselectAll: messages.deselectAll,
  save: messages.save,
  cancel: messages.cancel,
  emptyState: messages.emptyState,
}

export const SecondaryCategoryAccessGrid = ({
  user,
  secondaryCategoryOptions,
  isLoading,
  isSaving,
  onSave,
  onCancel,
}: ISecondaryCategoryAccessGridProps) => (
  <CatalogAccessGrid
    options={secondaryCategoryOptions}
    grantedIds={user.grantedSecondaryCategoryIds}
    getOptionLabel={(secondaryCategory) =>
      secondaryCategory.nameWithPrimaryCategory
    }
    resetKey={user.id}
    columns={2}
    isLoading={isLoading}
    isSaving={isSaving}
    onSave={onSave}
    onCancel={onCancel}
    messages={gridMessages}
  />
)
